export default "__VITE_ASSET__dd7b4173__$_?inline__"